"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabelFeedback = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _layout = require("../../layout");
var _FormLabelLabel = require("./FormLabelLabel");
const shouldForwardPropToBaseComponent = prop => {
  switch (prop) {
    // Add any props that should NOT be forwarded to Base Component here.
    case "themeMode":
      return false;
    default:
      return true;
  }
};
const FormLabelFeedback = (0, _styled.default)(_layout.Spacer, {
  shouldForwardProp: shouldForwardPropToBaseComponent
})`
    &:not(:empty) {
        margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _FormLabelLabel.labelStyles.margin(themeMode);
}}px;
    }
`;
exports.FormLabelFeedback = FormLabelFeedback;
//# sourceMappingURL=FormLabelFeedback.js.map